<template>
    <div class="serviceUnavailable">
        <div class="serviceUnavailable-img">
            <img class="serviceUnavailable-img-detail" src="../../assets/img/serviceUnavailable/503.png" alt="网站正在维护">
        </div>
        <div class="serviceUnavailable-content f24">Error，网站正在维护，请稍后重试~</div>
    </div>
</template>
<script>
export default {
  name: 'ServiceUnavailable',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
.serviceUnavailable{
    width: 100%;
    height: 100%;
    padding-top:13%;
    .serviceUnavailable-img{
        width: 34%;
        height: 46%;
        margin: 0 auto;
        .serviceUnavailable-img-detail{
            width: 100%;
            height: 100%;
        }
    }
    .serviceUnavailable-content{
        text-align: center;
        font-family:MicrosoftYaHei;
        font-weight:400;
        color:rgba(51,51,51,1);
        margin-top: 5%;
    }
}
</style>



// WEBPACK FOOTER //
// serviceUnavailable.vue?60b3eea4